<template>
  <v-dialog v-model="showModal" max-width="500px" persistent>
    <v-card flat>
      <v-toolbar dark class="primary">
        <v-btn icon @click.native="showModal = false" dark>
          <v-icon>fa-times</v-icon>
        </v-btn>
        <v-toolbar-title>Dodawanie nowej kategorii ICD9 dla terapeuty</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-container  grid-list-xl>
         <v-row>
           <v-col cols="12">
             <v-autocomplete v-model="selectedCategory" :items="items" label="Wybierz kategorie" :filter="filterIcd9">
               <template v-slot:selection="data">
                 {{ data.item.kod }} - {{data.item.opis}}
               </template>
               <template v-slot:item="data">
                 {{ data.item.kod }} - {{data.item.opis}}
               </template>
             </v-autocomplete>
           </v-col>
         </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="closeForm" color="error">Zamknij</v-btn>
        <v-btn color="success" @click="handleSubmit">Dodaj</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import swal from "sweetalert";
import {icdService} from "@/services";

export default {
  name: "AddICD9",
  data () {
    return {
      items: [],
      selectedCategory: null
    }
  },
  props: {
    visible: Boolean,
    actualTherapistCategories: Array,
  },
  mounted() {
    this.getICDValues()
  },
  methods: {
    handleSubmit() {
      this.$emit('onsubmit',this.selectedCategory)
    },
    filterIcd9(item,queryText) {
      const textOne = item.opis.toLowerCase()
      const textTwo = item.kod.toLowerCase()
      const searchText = queryText.toLowerCase()
      return textOne.indexOf(searchText) > -1 ||
          textTwo.indexOf(searchText) > -1
    },
    getICDValues()
    {
      icdService.getAllICD9MainCategories().then(data=> {
        if(data && data.data && data.data.result)
        {
          this.items = data.data.result
        }
        else
        {
          this.showError(false,'Błąd pobierania kategorii icd9.');
        }
      }).catch(() => {
        this.showError(false,'Błąd pobierania kategorii icd9.')
      })
    },
    closeForm() {
      this.$emit("close");
      this.clearFormData()
    },
    clearFormData() {
      this.selectedCategory = null
    },
    showError(close, text) {
      swal({
        title: "Błąd",
        text: text,
        icon: "warning",
        button: "OK"
      }).then(() => {
        this.loading = false;
        if (close) {
          this.$emit("close");
        }
      });
    },
  },
  computed: {
    showModal: {
      get: function() {
        if(!this.visible)
        {
          this.clearFormData()
        }
        return this.visible
      },
      set: function(value) {
        if(!value){
          this.$emit('close')
        }

      }
    }
  }
}
</script>

<style scoped>

</style>